var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarSaveForLater = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 17,
  viewBox: "0 0 12 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.375 0.5H1.625C1.29348 0.5 0.975537 0.631696 0.741116 0.866116C0.506696 1.10054 0.375 1.41848 0.375 1.75V15.5C0.375055 15.6115 0.404959 15.721 0.461608 15.8171C0.518256 15.9132 0.599586 15.9924 0.697156 16.0464C0.794726 16.1005 0.904983 16.1274 1.01648 16.1245C1.12798 16.1215 1.23666 16.0888 1.33125 16.0297L6 13.1117L10.6695 16.0297C10.7641 16.0886 10.8727 16.1212 10.9841 16.124C11.0955 16.1268 11.2056 16.0998 11.303 16.0458C11.4005 15.9918 11.4817 15.9127 11.5383 15.8167C11.5949 15.7208 11.6249 15.6114 11.625 15.5V1.75C11.625 1.41848 11.4933 1.10054 11.2589 0.866116C11.0245 0.631696 10.7065 0.5 10.375 0.5Z",
  fill: "#E1DFF2"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarSaveForLater);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_save_for_later.e4c595d70dcdbd575c872190f367a170.svg";